export default __webpack_public_path__ + "static/cpccg-569d9ba28159e7470a1055a92b364271.png";